import { AppError } from '@/utils/api';
import { AuthenticatedHttp } from '../../http/axios';

export const getCheckout = async ({ id }) =>
  AuthenticatedHttp.get(`/product/builder/checkout/${id}/`)
    .then(({ data }) => data)
    .catch((error) => {
      throw new AppError(error);
    });

export const getCheckouts = async ({ id, search = '', status = 'all', page = 1, limit = 10 }) =>
  AuthenticatedHttp.get(`/product/${id}/checkouts/`, {
    params: {
      page,
      search,
      limit,
      ...(status !== 'all' && { status }),
    },
  })
    .then(({ data: { results: checkouts, count } }) => ({
      checkouts,
      count,
    }))
    .catch((error) => {
      throw new AppError(error);
    });

export const createCheckoutService = async ({ id, ...data }) =>
  AuthenticatedHttp.post(`/product/${id}/checkouts/`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new AppError(error);
    });

export const updateCheckoutService = async ({ id, ...data }) =>
  AuthenticatedHttp.put(`/product/builder/checkout/${id}/`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new AppError(error);
    });

export const deleteCheckoutService = async (data) =>
  AuthenticatedHttp.delete(`/product/builder/checkout/${data.id}/`)
    .then((response) => response.data)
    .catch((error) => {
      throw new AppError(error);
    });

export const duplicateCheckoutService = async ({ id }) =>
  AuthenticatedHttp.post(`/product/builder/checkout/${id}/duplicate/`)
    .then((response) => response.data)
    .catch((error) => {
      throw new AppError(error);
    });

export const validateCouponService = async ({ code, offerId }) =>
  AuthenticatedHttp.post(`/coupons/validate/`, { code, offerId })
    .then(({ data }) => data)
    .catch((error) => {
      throw new AppError(error);
    });
